// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let DevelopmentUnitSearchResultActions_newDevelopmentUnit_graphql = require("../../../__generated__/DevelopmentUnitSearchResultActions_newDevelopmentUnit_graphql.bs.js");

let convertFragment = DevelopmentUnitSearchResultActions_newDevelopmentUnit_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, DevelopmentUnitSearchResultActions_newDevelopmentUnit_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(DevelopmentUnitSearchResultActions_newDevelopmentUnit_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, DevelopmentUnitSearchResultActions_newDevelopmentUnit_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(DevelopmentUnitSearchResultActions_newDevelopmentUnit_graphql.node, convertFragment, fRef);
}

let UnitFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function DevelopmentUnitSearchResultActions(props) {
  let match = RescriptRelay_Fragment.useFragment(DevelopmentUnitSearchResultActions_newDevelopmentUnit_graphql.node, convertFragment, props.unit);
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
      href: match.href,
      size: "small",
      className: "flex-1 justify-center",
      icon: "view-details",
      children: "View details"
    }),
    className: "flex gap-2"
  });
}

let make = DevelopmentUnitSearchResultActions;

exports.UnitFragment = UnitFragment;
exports.make = make;
/* ButtonsV5 Not a pure module */
